import adultPsychotherapyQuestionSet from "../faq/adultPsychotherapy/allQuestions";

export const psychoterapyAdult = {
    'meta': {
        'title': 'Psychoterapia #city# • Centrum COLLIGO',
        'description': 'Psychoterapia #city#. Psychoterapia prowadzona przez certyfikowanych psychoterapeutów, w nurcie psychodynamicznym lub poznawczo-behawioralnym.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'price': {
        'torun': {
            'first': 190,
            'next': 190
        },
        'bydgoszcz': {
            'first': 200,
            'next': 180
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/psychoterapia/',
        'title': 'Psychoterapia indywidualna #cityLocativeIn#',
        'name': 'Psychoterapia indywidualna osób dorosłych #cityLocativeIn#',
        'heading': 'Psychoterapia #city# - wsparcie dla osób dorosłych',
        'fullName': 'Psychoterapia indywidualna osób dorosłych'
    },
    'image': {
        'url': '/images/services/psychoterapia-indywidualna-doroslych.webp',
        'width': 886,
        'height': 295,
        'alt': 'Psychoterapia indywidualna'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/psychoterapia-indywidualna-doroslych.webp',
            'width': 886,
            'height': 295,
            'alt': 'Psychoterapia indywidualna'
        }
    },
    'faq': adultPsychotherapyQuestionSet
}